import { alpha, Box, Typography, useTheme } from '@mui/material';
import { LoadingButton } from '@mui/lab';

interface Props {
  isDelete?: boolean;
  routeName: string;
  isLoading: boolean;
}

const Header = ({ isDelete = false, routeName, isLoading }: Props) => {
  const { zIndex } = useTheme();
  const buttonColor = isDelete ? 'error' : 'primary';
  const buttonLabel = isDelete ? '刪除' : '保存';

  return (
    <Box
      top={-32}
      position="sticky"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        py: 2,
        mt: -12,
        zIndex: zIndex.appBar,
      }}
    >
      <Typography variant="h4"></Typography>
      <LoadingButton
        color={buttonColor}
        type="submit"
        variant="contained"
        loading={isLoading}
        sx={{ marginRight: '20px' }}
      >
        {buttonLabel}
      </LoadingButton>
    </Box>
  );
};

export default Header;
